import { MaxUint256 } from '@ethersproject/constants';

export const publicConfig = {
  isProd: process.env.NODE_ENV == 'production',
  maxApprove: MaxUint256,
  iotexTVL: 10000000
};
